import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from 'environments/environment';
import { Observable, Subject } from 'rxjs';
import { map, tap } from 'rxjs/operators';
import { Federation, Licence } from 'app/shared/models/class/federation/federation';

@Injectable({
  providedIn: 'root'
})
export class FederationsService {
  federations: Federation[] = [];
  federationsListChanged = new Subject<Federation[]>();
  licences: Licence[] = [];
  licencesListChanged = new Subject<Licence[]>();
  private baseUrl: string = environment.apiUrl + '/FederationLicence';

  constructor(
    private http: HttpClient
  ) { }

  /* -------------------------------------------------------------------------- */
  /*                                     GET                                    */
  /* -------------------------------------------------------------------------- */

  getFederations(): Observable<Federation[]> {
    return this.http.get<Federation[]>(`${this.baseUrl}`)
    .pipe(
      map(federations => {
        this.federations = federations.map(p => Federation.fromObject(p));
        this.federationsListChanged.next([...this.federations]);
        return [...this.federations];
      })
    );
  }

  getLicencesByClub(clubCode: string): Observable<Licence[]> {
    return this.http.get<Licence[]>(`${this.baseUrl}/Licence/${clubCode}`)
    .pipe(
      map(licences => {
        this.licences = licences.map(p => Licence.fromObject(p));
        this.licencesListChanged.next([...this.licences]);
        return [...this.licences];
      })
    );
  }

  getLicences(): Observable<Licence[]> {
    return this.http.get<Licence[]>(`${this.baseUrl}/Licence`)
    .pipe(
      map(licences => {
        this.licences = licences.map(p => Licence.fromObject(p));
        this.licencesListChanged.next([...this.licences]);
        return [...this.licences];
      })
    );
  }

  /* -------------------------------------------------------------------------- */
  /*                                    POST                                    */
  /* -------------------------------------------------------------------------- */

  addFederation(federation: Federation): Observable<Federation> {
    return this.http.post<Federation>(`${this.baseUrl}/Federation`, federation);
  }

  addLicence(licence: Licence): Observable<Licence> {
    return this.http.post<Licence>(`${this.baseUrl}/Licence`, licence);
  }

  /* -------------------------------------------------------------------------- */
  /*                                     PUT                                    */
  /* -------------------------------------------------------------------------- */

  updateFederation(federation: Federation) {
    return this.http.put(`${this.baseUrl}/Federation`, federation);
  }

  updateLicence(licence: Licence) {
    return this.http.put(`${this.baseUrl}/Licence`, licence);
  }

}
